// extracted by mini-css-extract-plugin
export default {"footerBtn":"PreCheckModal_footerBtn__qt+nm"};